import { Col, Row } from 'react-bootstrap';
import { TextInput } from '@orbita-ui/core';

interface DateRangeFilterProps {
  fechaDesde: string;
  fechaHasta: string;
  onDesdeChange: (value: string) => void;
  onHastaChange: (value: string) => void;
}

export const DateRangeFilter = ({
                                  fechaDesde,
                                  fechaHasta,
                                  onDesdeChange,
                                  onHastaChange,
                                }: DateRangeFilterProps) => {
  return (
    <Row>
      <Col className="mb-4">
        <TextInput
          id="fecha-desde"
          label="Desde"
          fullWidth
          type="date"
          value={fechaDesde}
          onChange={(e) => onDesdeChange(e.target.value)}
          required
        />
      </Col>
      <Col>
        <TextInput
          id="fecha-hasta"
          label="Hasta"
          fullWidth
          type="date"
          value={fechaHasta}
          onChange={(e) => onHastaChange(e.target.value)}
          required
        />
      </Col>
    </Row>
  );
};
